import assetPath from '/app/packages/lebenslauf/components/src/assets/ibm-plex-sans-bold.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')